"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopScanning = exports.startScanning = exports.stopAdvertising = exports.startAdvertising = void 0;
var bleModule = function () {
    var _a;
    var bluetooth = (_a = window.bleb) === null || _a === void 0 ? void 0 : _a.Bluetooth;
    if (bluetooth) {
        return bluetooth;
    }
    else {
        throw new Error('bleb is missing in current browser');
    }
};
var startAdvertising = function (uuid) {
    bleModule().startAdvertising(uuid);
};
exports.startAdvertising = startAdvertising;
var stopAdvertising = function () {
    bleModule().stopAdvertising();
};
exports.stopAdvertising = stopAdvertising;
var startScanning = function (callback) {
    bleModule().startScanning(callback);
};
exports.startScanning = startScanning;
var stopScanning = function () {
    bleModule().stopScanning();
};
exports.stopScanning = stopScanning;
